export default __webpack_public_path__ + "static/media/5c.1ea41c8b.png";